export const downloadFromABlob = (blob, fileName = '') => {
  const objectURL = URL.createObjectURL(blob);
  const anchorElement = document.createElement('a');
  anchorElement.href = objectURL;
  anchorElement.download = `${fileName}`;
  anchorElement.click();
}
